import React, { useState } from "react";
import Input from "../../../../../widget/common/form/Input";
import { NewPasswordContextImport } from "../../../../../provider/onboarding/forgot_password/new_password/NewPasswordContextProvider";

export const NewPasswordField = () => {
  const { passwords, handleOnChange, passwordsValidate, validateStatus } =
    NewPasswordContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };
  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="new_password"
      handleOnChange={handleOnChange}
      value={passwords.password}
      validate={true}
      label="new_password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={validateStatus ? !passwordsValidate.password : false}
      showPassHint={true}
    />
  );
};

export const NewPasswordConfirmField = () => {
  const { passwords, handleOnChange, passwordsValidate, validateStatus } =
    NewPasswordContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };

  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="password_confirm"
      handleOnChange={handleOnChange}
      value={passwords.password_confirm}
      validate={true}
      label="confirm_new_password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={validateStatus ? !passwordsValidate.confirm : false}
      showPassHint={true}
    />
  );
};
